import { render, staticRenderFns } from "./GiftsBoxProduct.vue?vue&type=template&id=ac792aa4&scoped=true&"
import script from "./GiftsBoxProduct.vue?vue&type=script&lang=js&"
export * from "./GiftsBoxProduct.vue?vue&type=script&lang=js&"
import style0 from "./GiftsBoxProduct.vue?vue&type=style&index=0&id=ac792aa4&lang=scss&scoped=true&"
import style1 from "./GiftsBoxProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac792aa4",
  null
  
)

export default component.exports